<mat-card appearance="outlined" class="full-height padding-0 border" [style.height.px]="height">
	<div class="full-height" style="overflow: auto">
		<form #alleForm="ngForm">
			<table mat-table [dataSource]="dataSource">
				<ng-container matColumnDef="shortName">
					<th mat-header-cell *matHeaderCellDef class="padding-right-7">
						<div fxLayout="row" fxLayoutAlign="start end">
							<div fxFlex="nogrow">
								<mat-checkbox
									[disabled]="readonly"
									id="master-toogle-{{ title }}{{ id }}"
									class="margin-right-10"
									(change)="masterToggle($event);change()"
									[checked]="selection.selected.length === data?.length && selection.selected.length > 0"
									[indeterminate]="
										selection.selected.length > 0 && selection.selected.length < dataSource?.data?.length
									"
									[disabled]="isFromEdit||isAllegationEdit||isClosedAllegationEdit"
									aria-label="Select all {{ title }}"
								>
								</mat-checkbox>
								<strong [ngClass]="enableSearch ? 'search-title' : 'benefit-title'">
									{{ title }}&nbsp;({{ selection?.selected?.length }}/{{ data?.length }})&nbsp;
								</strong>
							</div>
							<div fxFlex="grow">
								<input
									type="text"
									style="width: 94%;"
									*ngIf="enableSearch"
									class="mat-table-filter margin-left-10 margin-right-10"
									id="filter-{{ title }}"
									placeholder="Search"
									(click)="$event.stopPropagation()"
									(keyup)="applyFilter($event.target.value)"
									[disabled]="isFromEdit"
									[attr.aria-label]="'Search ' + title + ' list'"
								/>
								<div role="status" class="sr-only" aria-live="polite">
									<span *ngIf="ariaResultAlert === 1"> {{ ariaResultAlert }} result available. </span>
									<span *ngIf="ariaResultAlert === 0 || ariaResultAlert > 1">
										{{ ariaResultAlert }} results available
									</span>
								</div>
							</div>
						</div>
					</th>
					<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
					<th
						[ngClass]="{'highlight-background': (selection.isSelected(row?.shortName || row.id || row.hearingSharedCodeId ))}"
						mat-cell
						*matCellDef="let row; let i = index"
						[matTooltip]="row?.description || row?.shortName"
						[matTooltipDisabled]="row.isDisabled || readonly || row.tooltipDescription"
						[appAnnounceTooltip]="row.isDisabled || readonly || row.tooltipDescription ? '' : row.description"
						(click)="$event.stopPropagation(); checkAndFocus(row, $event)"
						id="click-allegation-row-{{ i }}"
						class="lead-col mat-mdc-cell"
					>
						<mat-checkbox
							(click)="$event.stopPropagation()"
							(change)="onRowSelect(row)"
							[checked]="selection.isSelected(row?.shortName || row.id || row.hearingSharedCodeId  )"
							[disabled]="row.isDisabled || readonly || isFromEdit || isClosedAllegationEdit"
							id="l-{{ title }}{{ id }}-{{ row?.shortName || row.id || row.hearingSharedCodeId }}" 
													>
							<span class="margin-left-10" (click)="selection.toggle(row.id || row.hearingSharedCodeId); change()">
								{{ row?.shortName || row?.description }}
							</span>
						</mat-checkbox>
					</th>
				</ng-container>
				<ng-container matColumnDef="ter">
					<th mat-header-cell *matHeaderCellDef class="amount-heading">TER</th>
					<td mat-cell *matCellDef="let row; let i = index" class="amount-heading">
						<mat-checkbox
							[(ngModel)]="row.isTargetedEquitableRelief"
							(ngModelChange)="selectRow(row, i)"
							[disabled]="row.isTerDisabled"
							name="ter-{{ title }}{{ id }}-{{ row.id }}"
							id="ter-{{ title }}{{ id }}-{{ row.id }}"
						>
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="amount">
					<th mat-header-cell *matHeaderCellDef class="amount-heading">{{ amountHeading }}</th>
					<td mat-cell *matCellDef="let row; let i = index" class="amount-heading">
						<div *ngIf="selection.isSelected(row.id || row.hearingSharedCodeId)">
							<div class="pos-rel dollor-amount">
								<input
									class="form-control"
									(click)="$event.stopPropagation()"
									[(ngModel)]="row.amount"
									(paste)="avoidSpecialChar($event)"
									onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode ==46 ||  event.charCode ==44 || event.charCode >= 48 && event.charCode <= 57))"
									name="amount-{{ title }}-{{ i }}"
									(ngModelChange)="emit(); change()"
									type="text"
									id="amount-{{ title }}{{ id }}"
								/>
								<span class="prepend-text">$</span>
							</div>
						</div>
					</td>
				</ng-container>
				<ng-container matColumnDef="expandedDetail">
					<td mat-cell *matCellDef="let row; let i = index" [attr.colspan]="displayColumn.length">
						<ng-container *ngIf="isSelected(row)">
							<mat-form-field
								*ngIf="!isAdditionalSelect(row)"
								class="input-full-width margin-top-10"
								appearance="outline"
							>
								<mat-label>{{ getBenefitTypeAdditionalTextLabel(row) }}</mat-label>
								<textarea
									cdkTextareaAutosize
									matInput
									#model="ngModel"
									[maxLength]="140"
									id="benefitTypeAdditionalText-{{ i }}"
									cdkAutosizeMinRows="3"
									cdkAutosizeMaxRows="3"
									[disabled]="row.isDisabled || readonly || isFromEdit || isClosedAllegationEdit"
									spellcheck="true"
									name="benefitTypeAdditionalText-{{ i }}"
									[placeholder]="getBenefitTypeAdditionalTextLabel(row)"
									[(ngModel)]="row.benefitTypeAdditionalText"
									(keyup)="emit(); change()"
									required
								></textarea>
								<span class="float-right text-area-count">{{ row.benefitTypeAdditionalText?.length || 0 }} / 140</span>
							</mat-form-field>

							<mat-form-field *ngIf="isAdditionalSelect(row)" class="input-95-width" appearance="outline">
								<mat-label>Select Training</mat-label>
								<mat-select
									placeholder="Reason"
									name="trainingTypes"
									[(ngModel)]="row.trainingTypes"
									(ngModelChange)="emit(); change()"
									multiple
									id="allegation-reason"
									required
								>
									<mat-option *ngFor="let item of trainingOptions" [value]="item.code">
										{{ item.description }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</ng-container>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayColumn; sticky: true"></tr>
				<tr
					class="mat-table-row"
					[ngClass]="{ 'mat-table-row-selected': selection.isSelected(row?.shortName || row.id || row.hearingSharedCodeId) }"
					[class.expanded]="showAdditionalTextBox(row)"
					mat-row
					matTooltipPosition="above"
					[matTooltip]="row.tooltipDescription"
					matTooltipClass="mat-deniel-tooltip"
					[appAnnounceTooltip]="row.tooltipDescription"
					*matRowDef="let row; columns: displayColumn"
				></tr>
				<tr
					mat-row
					*matRowDef="let row; let index = index; columns: ['expandedDetail']; when: isExpansionDetailRow"
					style="overflow: hidden"
					class="mat-table-row sample-expanded-row"
				></tr>
			</table>
		</form>
		<div class="flex align-loader" *ngIf="loading">
			<div>
				<mat-spinner style="margin: 0 auto" mode="indeterminate" diameter="40" id="spinner"></mat-spinner>
			</div>
		</div>
	</div>
</mat-card>
